module.exports = __webpack_public_path__ + "static/media/notif-bell.2cd87385.svg";